import React from 'react'
import Btn from 'components/Btn'

export default function Actions({ dataView, setView }) {
  return (
    <div className="w-[auto] py-5 ">
      <ul className="mx-auto grid lg:grid-cols-3 xs:grid-cols-12 gap-3 ">
        <li>
          <Btn
            content="General"  variant={'outlined'}
            className={`!w-[124px] !h-[48px] inline-block font-[700] text-[16px] rounded-xl ${dataView === 'general' ? ' text-primary' : 'bg-white border border-[#E6E8EB] text-[#657585]  hover:bg-primary hover:bg-opacity-30'}`}
            click={() => setView('general')}
          />
        </li>
        <li>
          <Btn
            content="Branch" variant={'outlined'}
            className={`!w-[124px] !h-[48px] inline-block font-[700] text-[16px] rounded-xl ${dataView === 'branch' ? ' text-primary' : 'bg-white border border-[#E6E8EB] text-[#657585]  hover:bg-primary hover:bg-opacity-30'}`}
            click={() => setView('branch')}
          />
        </li>
        <li>
          <Btn
            content="POS"  variant={'outlined'}
            className={`!w-[124px] !h-[48px] inline-block font-[700] text-[16px] rounded-xl ${dataView === 'pos' ? ' text-primary' : 'bg-white border border-[#E6E8EB] text-[#657585]  hover:bg-primary hover:bg-opacity-30'}`}
            click={() => setView('pos')}
          />
        </li>
      </ul>
    </div>
  )
}
 